import { generalReducer, GeneralState, generalStateInitial } from './reducers/GeneralReducer'
import { authReducer, AuthState, authStateInitial } from './reducers/AuthReducer'
import { redirectReducer, RedirectState, redirectStateInitial } from './reducers/RedirectReducer'
import { boreholeInfoReducer, BoreholeInfoState, boreholeInfoStateInitial } from './reducers/BoreholeInfoReducer'
import { virtualBoreholeInfoReducer, VirtualBoreholeInfoState, virtualBoreholeInfoStateInitial } from './reducers/VirtualBoreholeInfoReducer'
import { hydroModelReducer, HydroModelState, hydroModelStateInitial } from './reducers/HydroModelReducer'
import { mapReducer, MapState, mapStateInitial } from './reducers/MapReducer'
import { infoMenuReducer, InfoMenuState, infoMenuStateInitial } from './reducers/InfoMenuReducer'
import { profileReducer, ProfileState, profileStateInitial } from './reducers/ProfileReducer'
import { wikiReducer, WikiState, wikiStateInitial } from './reducers/WikiReducer'
import { persistStore, persistReducer, createMigrate, MigrationManifest } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import {SET_TOKEN} from './actions/AuthAction'

import thunk from 'redux-thunk'
import { createStore, applyMiddleware, combineReducers } from 'redux'

export interface RootState {
  generalState: GeneralState
  authState: AuthState
  redirectState: RedirectState
  boreholeInfo: BoreholeInfoState
  hydroModelState: HydroModelState
  virtualBoreholeInfoState: VirtualBoreholeInfoState
  mapState: MapState
  infoMenuState: InfoMenuState
  profileState: ProfileState
  wikiState: WikiState
}

export const rootStateInitial = {
  generalState: generalStateInitial,
  authState: authStateInitial,
  redirectState: redirectStateInitial,
  boreholeInfo: boreholeInfoStateInitial,
  hydroModelState: hydroModelStateInitial,
  virtualBoreholeInfoState: virtualBoreholeInfoStateInitial,
  mapState: mapStateInitial,
  infoMenuState: infoMenuStateInitial,
  profileState: profileStateInitial,
  wikiState: wikiStateInitial
}

const persistVersion = 6
const migrations: MigrationManifest = {}
migrations[persistVersion] = (state) => ({
  _persist: {
    version: 0,
    rehydrated: false
  }
})

// persist configurations
const rootPersistConfig = {
  key: 'root',
  version: persistVersion,
  storage,
  blacklist: ['authState'],
  migrate: createMigrate(migrations, { debug: false })
}

// persist config
const authPersistConfig = {
  key: 'authState',
  version: persistVersion,
  storage,
  blacklist: ['password', 'isLoginError'],
  migrate: createMigrate(migrations, { debug: false })
}

const rootReducer = combineReducers({
  generalState: generalReducer,
  authState: persistReducer(authPersistConfig, authReducer),
  redirectState: redirectReducer,
  hydroModelState: hydroModelReducer,
  boreholeInfo: boreholeInfoReducer,
  virtualBoreholeInfoState: virtualBoreholeInfoReducer,
  mapState: mapReducer,
  infoMenuState: infoMenuReducer,
  profileState: profileReducer,
  wikiState: wikiReducer
})

const persistedReducer = persistReducer(rootPersistConfig, rootReducer)

const refreshOnLoginMiddleware = (store:any) => (next:any) => (action:any) => {
  if (action.type === SET_TOKEN) {
    setTimeout(() => {window.location = "/"}, 500);
  }
  next(action);
}

const middlewares = [thunk, refreshOnLoginMiddleware]
const store = createStore(persistedReducer, applyMiddleware(...middlewares))
export const persistor = persistStore(store)

export default store
